/**
 * Regex pattern to match flight exchange paths.
 * Matches: /trips/flights/${itineraryId}/exchange/*
 * Prevents false positives like: /exchange-rates, /some-exchange-page
 */
const EXCHANGE_PATH_PATTERN = /\/trips\/flights\/[^/]+\/exchange(?:\/|$)/;

/**
 * Pure function to check if a given pathname is part of a flight exchange flow.
 * Use this in non-React contexts (Redux thunks, utilities, etc.).
 * For React components/hooks, prefer useIsExchangeFlow() for better reactivity.
 *
 * @param pathname - The pathname to check (defaults to window.location.pathname)
 * @returns true if the pathname matches the exchange flow pattern
 */
export const isExchangeFlow = (
  pathname: string = window.location.pathname
): boolean => {
  return EXCHANGE_PATH_PATTERN.test(pathname);
};
